import React, { Component } from 'react'
import { connect } from 'react-redux'
import './tools.css'
import { isIOs, isMobile } from '../../misc/selectors'
import Dropzone from 'react-dropzone'
import ExceedsLimitsModal from '../../misc/modals/ExceedsLimits'
import Generic from './Generic'
import Clipper from './Clipper'
import Compress from './Compress'
import Embed from './Embed'
import GlobalFooter from '../../nav/GlobalFooter'
import GlobalNav from '../../nav/GlobalNav'
import { Helmet } from "react-helmet";

const mapStateToProps = (state, ownProps) => {
  const { videos, me } = state

  return {
    isIOs: isIOs(state),
    me,
    isMobile: isMobile(state),
    view: ownProps.viewParams.view
  }
}

class Tool extends Component {
  fileInput = React.createRef();
  urlInput = React.createRef();
  state = {}

  componentDidMount() {
    const self = this
    document.onpaste = (e) => {
      if (e.target.id == 'primary-url-input') return;
      let paste = (e.clipboardData || window.clipboardData).getData('text');
      self.setState({url: paste})
    }
  }

  componentWillUnmount() {
    document.onpaste = null;
  }

  render() {
    const { me, dispatch, } = this.props
    const self = this

    return (
      <Dropzone
        onDrop={(acceptedFiles, rejectedFiles) => {
          self.setState({file: acceptedFiles[0]})
        }}
        noClick
      >
        {({getRootProps, getInputProps, isDragActive}) => (
          
        <div 
          className="tool-container"
          {...getRootProps()}
        > 
          <Helmet>
            <title>{window._STM_PREDATA[this.props.view].title}</title>
            <meta name="description" content={window._STM_PREDATA[this.props.view].description}></meta>
          </Helmet>
          <div className="background-top"></div>
          <GlobalNav />
          {isDragActive ? <div className="drop-accepted"><div className="drop-accepted-text">Drop anywhere.</div></div> : ''}
          <input {...getInputProps()} />
          <ExceedsLimitsModal />
          {this.props.view == 'compress' ?
            <Compress file={self.state.file} />
          : this.props.view == 'embed' ?
            <Embed file={self.state.file} url={self.state.url} />
          : this.props.view == 'clipper' ?
            <Clipper url={self.state.url} />
          :
            <Generic action={this.props.view} file={self.state.file} url={self.state.url} />
          }
          <div className="stats-pane">
            <h2>Streamable is loved by over 50 million users and customers from 122 countries</h2>
            <div className="testimonials">
              <div className="testimonial">
                <img className="photo" src="https://statics.streamable.com/static/landing/case.png"></img>
                <div className="testimonial-content">
                  <img className="stars" src="https://statics.streamable.com/static/landing/stars.png"></img>
                  <div className="testimonial-text">
                    {`“Shout out to @streamable for being the best video service for mocking up and sharing ideas. Love you guys <3”`}
                  </div>
                  <div className="testimonial-name">
                    <b>Case Harts</b> &mdash; SBNation
                  </div>
                </div>
              </div>
              




              <div className="testimonial">
                <img className="photo" src="https://statics.streamable.com/static/landing/kami.jpeg"></img>
                <div className="testimonial-content">
                  <img className="stars" src="https://statics.streamable.com/static/landing/stars.png"></img>
                  <div className="testimonial-text">
                  “@streamable you provide an awesome service! 🚀 Thank you very much 🎙🎧🕹”
                  </div>
                  <div className="testimonial-name">
                    <b>Kami Hashinda</b> &mdash; Twitter
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <div className="background" />
            <GlobalFooter />
          </div>
        </div>)}
      </Dropzone>
    )
  }
}

export default connect(mapStateToProps)(Tool)
